import { RefreshCw } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PullIndicatorProps {
  distance: number;
  isRefreshing: boolean;
  threshold: number;
}

export function PullIndicator({ distance, isRefreshing, threshold }: PullIndicatorProps) {
  const visible = distance > 0 || isRefreshing;
  if (!visible) return null;

  const height = isRefreshing ? 44 : distance;
  const ready = distance >= threshold;

  return (
    <div
      style={{ height }}
      className="flex shrink-0 items-center justify-center overflow-hidden"
      aria-hidden
    >
      <RefreshCw
        className={cn(
          'h-4 w-4 text-primary transition-transform duration-100',
          (isRefreshing || ready) && 'animate-spin',
        )}
        style={
          isRefreshing || ready
            ? undefined
            : { transform: `rotate(${Math.min(360, distance * 4)}deg)`, opacity: distance / threshold }
        }
      />
    </div>
  );
}
